import React, { useState } from 'react';
import { Button, message, Modal } from 'antd';
import { Container } from './styles';
import { ModalBody } from '../../../components/Modals/styles';
import { INSERTS_TAB } from './translationValues';
import { deleteOrganizationInsert } from '../../../utils/services/insertsApi';

export const InsertDeleteModal = ({ insert, visible, onCancel, t, onDeleteSuccess }) => {
  const [deleting, setDeleting] = useState(false);

  const onDelete = async () => {
    setDeleting(true);
    const payload = { id: insert.id };
    try {
      const response = await deleteOrganizationInsert(payload);
      if (response?.statusCode === 127) {
        onDeleteSuccess && onDeleteSuccess();
        message.success(
          t(INSERTS_TAB.INSERT_DELETE_SUCCESS.key, INSERTS_TAB.INSERT_DELETE_SUCCESS.value),
        );
        onCancel();
      }
    } catch (e) {
      message.error(
        t(INSERTS_TAB.INSERT_DELETE_FAILURE.key, INSERTS_TAB.INSERT_DELETE_FAILURE.value),
      );
    } finally {
      setDeleting(false);
    }
  };
  return (
    <Container onKeyDown={e => e.stopPropagation()}>
      <Modal
        title={t(INSERTS_TAB.DELETE_INSERT_LABEL.key, INSERTS_TAB.DELETE_INSERT_LABEL.value)}
        centered
        visible={visible}
        width="625px"
        onCancel={onCancel}
        footer={[
          <Button key="back" onClick={onCancel}>
            {t(INSERTS_TAB.CANCEL_LABEL.key, INSERTS_TAB.CANCEL_LABEL.value)}
          </Button>,
          <Button key="submit" type="primary" loading={deleting} onClick={onDelete}>
            {deleting
              ? t(INSERTS_TAB.DELETING_LABEL.key, INSERTS_TAB.DELETING_LABEL.value)
              : t(INSERTS_TAB.DELETE_LABEL.key, INSERTS_TAB.DELETE_LABEL.value)}
          </Button>,
        ]}
        className="warning-modal"
      >
        <ModalBody>
          <div className="warning-text">
            <span>
              {t(
                INSERTS_TAB.DELETE_INSERT_QUESTION_LABEL.key,
                INSERTS_TAB.DELETE_INSERT_QUESTION_LABEL.value,
              )}
            </span>
            {insert && insert.name && <span className="text-highlighter">{insert.name}</span>}
            <span>?</span>
          </div>
        </ModalBody>
      </Modal>
    </Container>
  );
};
